import React, { useEffect, useState } from "react";
import { Button } from "@project-stories/elements/Button/Button";
import useMobileBreakpoint from "@arctheme-hooks/useMobileBreakpoint";
import { useHubSpotForm } from "@src/hooks/useHubSpotForm";

interface ReadyTransformProps {
  settings: {
    section: {
      title?: string;
      title_font_style?: string;
      title_font_style_mobile?: string;
      description?: string;
      desc_font_style?: string;
      desc_font_style_mobile?: string;
      placeholder?: string;
      button_text?: string;
      section_hubspot_form_id?: string;
      section_hubspot_region?: string;
      helper_text?: string;
      helper_text_aligned?: string;
      background_arc_block?: string;
      inside_padding_x_desktop?: number;
      inside_padding_x_mobile?: number;
      inside_padding_y_desktop?: number;
      inside_padding_y_mobile?: number;
    };
    mobile_breakpoint?: string;
  };
}

export const ReadyTransform: React.FC<ReadyTransformProps> = ({ settings }) => {
  const isMobile = useMobileBreakpoint(settings.mobile_breakpoint || "1024px");
  const section = settings.section || {};
  const blocks = settings.blocks || [];
  const checklistItems = blocks.filter((block) => block.type === 'checklist');
  const [email, setEmail] = useState('');

  const { openForm } = useHubSpotForm({
    portalId: settings.globals.hubspot.portal_id,
    formId: section.section_hubspot_form_id ? section?.section_hubspot_form_id : settings.globals.hubspot.form_id,
    region: section.section_hubspot_region ? section?.section_hubspot_region : settings.globals.hubspot.form_region,
    defaultValues: {
      'email': email,
    }
  });

  const handleContactSubmit = () => {
    if (email) {
      openForm();
    }
  };

  return (
    <div className={`flex flex-col relative w-full overflow-hidden
      px-[${section.inside_padding_x_mobile}px]
      lg:px-[${section.inside_padding_x_desktop || 0}px]
      py-[${section.inside_padding_y_mobile || 0}px]
      lg:py-[${section.inside_padding_y_desktop || 0}px]`}
    >
      <div className="flex flex-col gap-8 flex-1 max-w-[768px]">
        <div className="flex flex-col justify-start items-start gap-6">
          {section.title && (
            <h2 className={`${isMobile ? section.title_font_style_mobile : section.title_font_style}`}>
              {section.title}
            </h2>
          )}

          {section.description && (
            <div className={`${isMobile ? section.desc_font_style_mobile : section.desc_font_style}`}>
              {section.description}
            </div>
          )}
        </div>

        <div className={`grid grid-cols-1 lg:grid-cols-2 gap-y-6 gap-x-4`}>
          { checklistItems.map((item, idx) => (
            <div key={idx} className="inline-flex items-start gap-3">
              <div className="flex justify-center items-center w-6 h-6 p-[2.53px] bg-[#D6CFF8] rounded-full">
                <div className="w-5 h-5 relative overflow-hidden icon-check text-[#1C1C1F] text-center text-[18px]">
                </div>
              </div>
              <div className="flex-1 flex justify-start items-center gap-1">
                <div className={`flex-1 ${isMobile ? item.settings.font_type_mobile : item.settings.font_type}`}>{item.settings.content}</div>
              </div>
            </div>
          ))}
        </div>

        <div className={"flex flex-col gap-4 pt-4"}>
          <form className="flex-1 flex flex-col lg:flex-row items-center gap-4"
            onSubmit={(e) => {
              e.preventDefault();
              handleContactSubmit();
            }}
          >
            <div className="max-lg:w-full lg:flex-1 bg-white outline outline-1 outline-white">
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder={section.placeholder || "Enter your email"}
                className="w-full p-3 b_regular_normal"
                style={{ color: '#1C1C1F' }}
                required
              />
            </div>
            <Button
              type="submit"
              className={`max-lg:!w-full b_regular_normal !tracking-[0.4px]`}
              style = 'secondary'
              text={true}
              label={section.button_text}
              icon={`right-arrow-alt`}
              onClick={undefined}
            />
          </form>
          {section.helper_text && (
            <div className={`b_tiny_normal ${isMobile ? `text-${section.helper_text_aligned}` : ''}`}>
              {section.helper_text}
            </div>
          )}
        </div>
      </div>
      <div className="max-lg:hidden absolute inset-0 pointer-events-none z-10">
        <div className="absolute bottom-0 right-0 w-[370px] h-[390px]"
          style={{ 
            background: `url(${section.background_arc_block}) no-repeat`
          }}
        />
      </div>
    </div>
  );
};

export default ReadyTransform;


